// Backend timestamps are Python `datetime.utcnow()` values serialized
// without a timezone designator (e.g. "2026-07-08T14:06:20.659621", no
// trailing "Z" or "+00:00" -- the value IS UTC, the string just doesn't say
// so). Per the ECMAScript spec, `new Date(...)` on an ISO string with no
// timezone designator parses it as *local* time, not UTC. Without this
// normalization, every displayed/calculated time is silently off by
// exactly the viewer's UTC offset (5h30m early for IST, for example) --
// this hit both display (dates looking wrong) and real logic (wait/overdue
// minute calculations reading as hours more elapsed than reality).
export function parseUtcTimestamp(value: string): Date {
  const hasTimezoneDesignator = /[zZ]|[+-]\d{2}:?\d{2}$/.test(value);
  return new Date(hasTimezoneDesignator ? value : `${value}Z`);
}
